import type { TersaImageModel } from '../types';
import { providers } from '../../providers';
import { youchuan } from '../youchuan';

// 美元汇率
const RMB_TO_USD = 1 / 6.8;
// rmb to usd 转换
const usd = (rmb: number) => rmb * RMB_TO_USD;
// 系数
const COST_FACTOR = 1.5;

export const midjourneyModels: Record<string, TersaImageModel> = {
    'midjourney-v8.2': {
        chef: providers.midjourney,
        providers: [
            {
                ...providers.midjourney,
                model: undefined,
                model_create: youchuan.image('youchuan-t2i-v8.2'),
                model_edit: youchuan.image('youchuan-i2i-v8.2'),
                getCost: ({ providerOptions } = {}) => {
                    const resolution = (providerOptions?.image_resolution || '2K').toUpperCase();
                    if (resolution === '1K') return usd(0.6 * COST_FACTOR);
                    if (resolution === '2K') return usd(0.9 * COST_FACTOR);
                    return usd(0.9 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '6x5', '5x6', '4x3', '3x4', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K'],
            },
            i2i: {
                sizes: ['16x9', '9x16', '6x5', '5x6', '4x3', '3x4', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'midjourney-v8.1': {
        chef: providers.midjourney,
        providers: [
            {
                ...providers.midjourney,
                model: undefined,
                model_create: youchuan.image('youchuan-t2i-v8.1'),
                model_edit: youchuan.image('youchuan-i2i-v8.1'),
                getCost: ({ providerOptions } = {}) => {
                    const resolution = (providerOptions?.image_resolution || '2K').toUpperCase();
                    if (resolution === '1K') return usd(0.6 * COST_FACTOR);
                    if (resolution === '2K') return usd(0.9 * COST_FACTOR);
                    return usd(0.9 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '6x5', '5x6', '4x3', '3x4', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K'],
            },
            i2i: {
                sizes: ['16x9', '9x16', '6x5', '5x6', '4x3', '3x4', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'midjourney-v7': {
        chef: providers.midjourney,
        providers: [
            {
                ...providers.midjourney,
                model: undefined,
                model_create: youchuan.image('youchuan-t2i-v7'),
                model_edit: youchuan.image('youchuan-i2i-v7'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return usd(0.9 * COST_FACTOR);
                    return usd(0.6 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '6x5', '5x6', '4x3', '3x4', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['16x9', '9x16', '6x5', '5x6', '4x3', '3x4', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'midjourney-niji-7': {
        chef: providers.midjourney,
        providers: [
            {
                ...providers.midjourney,
                model: undefined,
                model_create: youchuan.image('youchuan-t2i-niji7'),
                model_edit: youchuan.image('youchuan-i2i-niji7'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return usd(0.9 * COST_FACTOR);
                    return usd(0.6 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '6x5', '5x6', '4x3', '3x4', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['16x9', '9x16', '6x5', '5x6', '4x3', '3x4', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};